import { render, staticRenderFns } from "./TranslationFilters.vue?vue&type=template&id=85f4bfee&scoped=true&"
import script from "./TranslationFilters.vue?vue&type=script&lang=js&"
export * from "./TranslationFilters.vue?vue&type=script&lang=js&"
import style0 from "./TranslationFilters.vue?vue&type=style&index=0&id=85f4bfee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4bfee",
  null
  
)

export default component.exports